import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';


if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('firebase-messaging-sw.js')
    .then(reg => {
      console.log('✅ Service Worker registered', reg);
    })
    .catch(err => {
      console.error('❌ Service Worker registration failed:', err);
    });
}


bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
